import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  editedMessage: {
    defaultValue: 'Pasta editada com sucesso',
    key: 'edit-dashboard-folder-modal-editedMessage',
  },
})
